module.exports = __webpack_public_path__ + "html/studio-header_fcc27ea6f7101e4ec0a54ca6d124cbb4.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 153